import { Image, UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './BubbleMessage.css';
import { TMessageBubbleTitle } from '../../types/messageBubble';

type TBubblesMessageProps = {
  title: TMessageBubbleTitle;
  buttonsNode: React.ReactNode | null;
  textFieldNode: React.ReactNode | null;
};

export const BubbleMessage: React.VFC<TBubblesMessageProps> = ({ title, textFieldNode, buttonsNode }) => {
  const hasIcon = Boolean(title.icon);

  return (
    <div className={classNames(styles['container'], hasIcon && styles['container_with_icon'])}>
      <div className={styles['title']} data-name="BubbleMessage_title">
        {hasIcon ? <Image src={title.icon as string} alt="Иконка сообщения" width={16} height={16} /> : null}
        <UIText1>{title.label}</UIText1>
      </div>
      {textFieldNode}
      {buttonsNode ? (
        <div className={classNames(styles['buttons'], hasIcon && styles['buttons_with_icon'])}>{buttonsNode}</div>
      ) : null}
    </div>
  );
};
